export const GANTT_COLORS = [
  { bar: '#3b82f6', light: '#dbeafe', text: '#1d4ed8' }, // blue
  { bar: '#10b981', light: '#d1fae5', text: '#065f46' }, // emerald
  { bar: '#8b5cf6', light: '#ede9fe', text: '#5b21b6' }, // violet
  { bar: '#f59e0b', light: '#fef3c7', text: '#92400e' }, // amber
  { bar: '#ef4444', light: '#fee2e2', text: '#991b1b' }, // red
  { bar: '#06b6d4', light: '#cffafe', text: '#155e75' }, // cyan
  { bar: '#f97316', light: '#ffedd5', text: '#9a3412' }, // orange
  { bar: '#6366f1', light: '#e0e7ff', text: '#3730a3' }, // indigo
  { bar: '#ec4899', light: '#fce7f3', text: '#9d174d' }, // pink
  { bar: '#14b8a6', light: '#ccfbf1', text: '#134e4a' }, // teal
]

export const parseDate = (s: string): Date => new Date(s + 'T00:00:00')

export const diffDays = (a: Date, b: Date): number =>
  Math.round((b.getTime() - a.getTime()) / 86400000)

export const addDays = (d: Date, n: number): Date => {
  const r = new Date(d)
  r.setDate(r.getDate() + n)
  return r
}

export const formatDate = (d: Date): string =>
  d.toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' })

export const formatMonth = (d: Date): string =>
  d.toLocaleDateString('it-IT', { month: 'short', year: '2-digit' })

/** Calcola minDate e maxDate dall'insieme di date visibili */
export function calcRange(dates: (string | null)[]): { minDate: Date; maxDate: Date } | null {
  const valid = dates.filter(Boolean).map(d => parseDate(d!))
  if (valid.length === 0) return null
  const min = new Date(Math.min(...valid.map(d => d.getTime())))
  const max = new Date(Math.max(...valid.map(d => d.getTime())))
  // Padding: 2 settimane prima e 4 settimane dopo
  return { minDate: addDays(min, -14), maxDate: addDays(max, 28) }
}

/** Genera tick mensili per l'header */
export function buildMonthTicks(minDate: Date, maxDate: Date): { label: string; startDay: number; days: number }[] {
  const ticks: { label: string; startDay: number; days: number }[] = []
  const cur = new Date(minDate.getFullYear(), minDate.getMonth(), 1)
  while (cur <= maxDate) {
    const monthStart = cur < minDate ? minDate : new Date(cur)
    const nextMonth = new Date(cur.getFullYear(), cur.getMonth() + 1, 1)
    const monthEnd = nextMonth > maxDate ? maxDate : new Date(nextMonth.getTime() - 86400000)
    ticks.push({
      label: cur.toLocaleDateString('it-IT', { month: 'long', year: 'numeric' }),
      startDay: diffDays(minDate, monthStart),
      days: diffDays(monthStart, monthEnd) + 1,
    })
    cur.setMonth(cur.getMonth() + 1)
  }
  return ticks
}

/** Genera tick settimanali per l'header */
export function buildWeekTicks(minDate: Date, maxDate: Date): { label: string; startDay: number }[] {
  const ticks: { label: string; startDay: number }[] = []
  // Trova il lunedì della prima settimana
  const first = new Date(minDate)
  const dow = first.getDay() === 0 ? 6 : first.getDay() - 1
  first.setDate(first.getDate() - dow)
  const cur = new Date(first)
  while (cur <= maxDate) {
    const sd = diffDays(minDate, cur)
    if (sd >= 0) {
      ticks.push({ label: formatDate(cur), startDay: sd })
    }
    cur.setDate(cur.getDate() + 7)
  }
  return ticks
}
